"use client";

import { cn } from "@/lib/utils";
import { Cell, flexRender } from "@tanstack/react-table";

export default function TableCell<T>({ cell }: { cell: Cell<T, unknown> }) {
  return (
    <div
      key={cell.id}
      tabIndex={cell.id as unknown as number}
      className={cn(
        "app-table-cell flex min-h-[65px] w-full items-center border border-transparent bg-white px-3 py-2 text-sm transition-colors duration-300 focus-within:border-[#2196f3] focus:border-[#2196f3]",
        {
          product_filter_sticky: cell.column.id === "material_number",
        }
      )}
      style={{
        width: cell.column.getSize(),
      }}>
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </div>
  );
}
